module.exports = __webpack_public_path__ + "img/7.9640c361.png";